// frontend/src/api/ingestion.js

async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const detail = isJson && payload ? payload.detail : null;
    const message =
      (isJson && payload && payload.message) ||
      (typeof detail === "string" && detail) ||
      (detail && typeof detail === "object" && (detail.error || JSON.stringify(detail))) ||
      (typeof payload === "string" && payload) ||
      `${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return payload;
}

/**
 * POST /api/ingestion/wipe-reingest
 * Deletes discovered_documents and inserts a new ingest_request for the org.
 */
export async function wipeReingest(orgId) {
  const res = await fetch("/api/ingestion/wipe-reingest", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ org_id: orgId }),
  });
  return parseResponse(res);
}

/**
 * POST /api/ingestion/ingest-new
 * Inserts a new ingest_request carrying the previous request's metadata.
 */
export async function ingestNew(orgId) {
  const res = await fetch("/api/ingestion/ingest-new", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ org_id: orgId }),
  });
  return parseResponse(res);
}

/**
 * GET /api/ingestion/errors?org_id=X
 * Returns all files with status='error' from loaded_files and extracted_documents.
 */
export async function getIngestionErrors(orgId) {
  const res = await fetch(`/api/ingestion/errors?org_id=${orgId}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  return parseResponse(res);
}

/**
 * POST /api/ingestion/retry-errors
 * Resets specific errored files back to 'new' and triggers a new ingest_request.
 * @param {number} orgId
 * @param {Array<{layer: string, filepath: string}>} errors
 */
export async function retryErrors(orgId, errors) {
  const res = await fetch("/api/ingestion/retry-errors", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ org_id: orgId, errors }),
  });
  return parseResponse(res);
}

/**
 * GET /api/ingestion/status?org_id=X
 * Returns per-layer ingestion counts for the org's tenant DB.
 */
export async function getIngestionStatus(orgId) {
  const res = await fetch(`/api/ingestion/status?org_id=${orgId}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  return parseResponse(res);
}
